<dt-modal-content size="small" (closeClick)="close()">
  <ng-template #title i18n>Passwort zurücksetzen</ng-template>
  <ng-template #content>
    @if (done) {
      <p i18n>Dir wurde eine E-Mail zum Zurücksetzen Deines Passworts zugeschickt.</p>
      <p i18n>Keine E-Mail erhalten? Prüfe Deinen Spam Ordner.</p>
    } @else {
      <form #actualForm="ngForm" class="dt-form" (ngSubmit)="onSubmit()" [formGroup]="resetForm">
        <mat-form-field>
          <mat-label i18n>E-Mail-Adresse</mat-label>
          <input type="email" matInput formControlName="email" required />
          @if (resetForm.hasError('required', 'email')) {
            <mat-error i18n>Bitte gib eine E-Mail-Adresse an</mat-error>
          }
          @if (resetForm.hasError('email', 'email')) {
            <mat-error i18n>Bitte gib eine gültige E-Mail-Adresse an</mat-error>
          }
        </mat-form-field>
        @if (resetForm.getError('server-error') === 'rate-limit') {
          <mat-error i18n>Du hast in kurzer Zeit zu viele Anfragen gestellt. Bitte versuche es später noch einmal.</mat-error>
        }
        @if (resetForm.getError('server-error') === 'account-not-found') {
          <mat-error i18n>Es existiert kein Account zu dieser E-Mail-Adresse.</mat-error>
        }
        @if (resetForm.getError('server-error') === 'something') {
          <mat-error i18n>Bei der Übertragung der Daten ist ein Fehler aufgetreten.</mat-error>
        }
        <button
          mat-raised-button
          [dtOverlayProgress]="resetForm.disabled"
          type="submit"
          color="accent"
          [disabled]="(!resetForm.valid && !actualForm.submitted) || resetForm.disabled"
          i18n
          >Passwort zurücksetzen</button
        >
      </form>
    }
  </ng-template>
</dt-modal-content>
